import qs from 'qs';
import useAPI from '../core/hooks/useApi';

export const useGetSitesByOptInId = optInId => useAPI(`/api/sites?${qs.stringify({ optInId })}`);
